export const initial = {
  isMenuShown: false,
};

export const test = {
  isMenuShown: false,
};
